import React, { useEffect, useRef, useState } from "react";

interface PowerBIProps {
  desktopReportId: string;
  desktopEmbedUrl: string;
  desktopToken: string;

  mobileReportId?: string;
  mobileEmbedUrl?: string;
  mobileToken?: string;
}

const PowerBI: React.FC<PowerBIProps> = (props) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  // Track screensize to set which report variant to display
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );
  useEffect(() => {
    const update = () => setIsMobile(window.innerWidth < 768);
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  // If report with mobile layout exists, display this on small screens
  const useMobile =
    isMobile &&
    props.mobileReportId &&
    props.mobileEmbedUrl &&
    props.mobileToken;

  const reportId = useMobile ? props.mobileReportId! : props.desktopReportId;
  const embedUrl = useMobile ? props.mobileEmbedUrl! : props.desktopEmbedUrl;
  const token = useMobile ? props.mobileToken! : props.desktopToken;

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!containerRef.current) return;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const w = window as any;

    const powerbiService = w.powerbi;
    const powerbiClient = w["powerbi-client"];

    if (!powerbiService || !powerbiClient) {
      return;
    }
    powerbiService.reset(containerRef.current);
    const models = powerbiClient.models;

    const config = {
      type: "report",
      id: reportId,
      embedUrl: embedUrl,
      accessToken: token,
      tokenType: models.TokenType.Embed,
      settings: {
        background: models.BackgroundType.Transparent,
        panes: {
          filters: { visible: false },
          pageNavigation: { visible: false },
        },
      },
    };

    powerbiService.embed(containerRef.current, config);

    return () => {
      powerbiService.reset(containerRef.current);
    };
  }, [reportId, embedUrl, token]);

  return (
    <div
      ref={containerRef}
      id={reportId}
      className={`powerbiContainer ${useMobile ? "mobileView" : ""}`}
    />
  );
};

export default PowerBI;
